// Слот баннеров над содержимым экрана (GarminBanner-слот).
// Область подключает свой баннер файлом src/pages/<area>/banner.tsx с `export function Banner()`;
// баннер сам решает, показываться ли (возвращает null, если нечего сказать). Оболочку не трогать.

import type { ComponentType } from 'react'

type BannerModule = { Banner?: ComponentType }

const modules = import.meta.glob<BannerModule>('../../pages/**/banner.tsx', { eager: true })

const banners = Object.keys(modules)
  .sort()
  .map((key) => ({ key, Banner: modules[key]?.Banner }))
  .filter((b): b is { key: string; Banner: ComponentType } => Boolean(b.Banner))

export function BannerSlot() {
  if (banners.length === 0) return null
  return (
    <div className="flex flex-col">
      {banners.map(({ key, Banner }) => (
        <Banner key={key} />
      ))}
    </div>
  )
}
